import { useMutation, useQueryClient } from '@tanstack/react-query';
import { massForceDeleteAgencies } from '../../api/apiAgencies';
import toast from 'react-hot-toast';

export const useMassForceDeleteAgencies = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: massForceDeleteAgencies,
        onSuccess: (data) => {
            queryClient.invalidateQueries({ queryKey: ['agencies'] });
            toast.success(data.message || 'Agencies permanently deleted successfully');
        },
        onError: (error) => {
            const errorMessage = error.response?.data?.message || 'Failed to permanently delete agencies';
            toast.error(errorMessage);
        },
    });
};
